
const typeMentorCreate = [
    ['incubator', 'Incubator'],
    ['fablab', 'Fablab'],
    ['p.p', 'Public/private'],
    ['accel', 'Accelerator'],
    ['assoc', 'Association'],
];

export default typeMentorCreate;